module.exports = __webpack_public_path__ + "static/media/user-icon.69d2ed55.jpg";